import React from 'react';
import { CalendarIcon } from 'lucide-react';
export function Navbar() {
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-100" data-id="element-99">
      <div className="max-w-7xl mx-auto px-6 py-4" data-id="element-100">
        <div className="flex items-center justify-between" data-id="element-101">
          {/* Logo */}
          <div className="flex items-center gap-2" data-id="element-102">
            <div className="w-10 h-10 bg-gradient-to-br from-orange-400 to-orange-600 rounded-xl flex items-center justify-center" data-id="element-103">
              <CalendarIcon className="w-6 h-6 text-white" data-id="element-104" />
            </div>
            <span className="text-xl font-bold text-gray-900" data-id="element-105">Famday</span>
          </div>

          {/* Nav links */}
          <div className="hidden md:flex items-center gap-8" data-id="element-106">
            <a href="#features" className="text-gray-600 hover:text-gray-900 transition-colors" data-id="element-107">
              Features
            </a>
            <a href="#download" className="text-gray-600 hover:text-gray-900 transition-colors" data-id="element-108">
              Download
            </a>
          </div>

          {/* CTA Button */}
          <button className="bg-gradient-to-r from-orange-500 to-orange-600 text-white px-6 py-2.5 rounded-full font-medium hover:shadow-lg hover:scale-105 transition-all" data-id="element-109">
            Download App
          </button>
        </div>
      </div>
    </nav>;
}